import moment from "moment"
import styled from "styled-components"
import { PAYMENT_STATUS, Products } from "../../commons/Const"
import PaymentHistory from "../../models/PaymentHistory.model"
import { addComma } from "../../utils/Utils"
import { useEffect, useState } from "react"

type HistoryItemProps = {
  history: PaymentHistory
}

export default function HistoryItem(props: HistoryItemProps) {

  const [round, setRound] = useState('');

  useEffect(() => {

    if(props.history.subscription === null) return;
    if(props.history.startedAt === null) return;

    const subscriptionStartDate = new Date(props.history.subscription.createdAt);
    subscriptionStartDate.setHours(0);
    subscriptionStartDate.setMinutes(0);
    subscriptionStartDate.setSeconds(0);
    subscriptionStartDate.setMilliseconds(0);

    const startDate = new Date(props.history.startedAt);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);

    const subscriptionStartMoment = moment(subscriptionStartDate);

    const diffDays = moment(startDate).diff(subscriptionStartMoment, 'month');

    setRound(`${props.history.startRound}`);

  }, [])
  return (
    <HistoryDiv className="history_item flex ai-c jc-sb">
      <div>
        {(props.history.type === 0 || props.history.type === 2) && <p className="turn">{round}회차</p>}
        <p className="fs16">{props.history.product}</p>
        {props.history.paidAt !== null && <p className="date">{moment(props.history.paidAt).format('YYYY.MM.DD HH:mm:ss')}</p>}
        {(props.history.type === 0 || props.history.type === 2) && props.history.status === PAYMENT_STATUS.CANCEL && (
          <p>구독 취소로 인한 결제취소</p>
        )} 
      </div>
      <div className="history_item_right">
        <p>{addComma(props.history.amount)} 원</p>
        {props.history.userCouponList.length !== 0 && (
          <span className="used_coupon">{props.history.userCouponList[0].coupon.name} 사용</span>
        )}
      </div>
    </HistoryDiv>
  )
}

const HistoryDiv = styled.div`
  + .history_item{
    border-top: 1px solid var(--gray_e);
  }

  .turn, .date{
    color: #555;
  }

  .turn + .fs16{
    margin: 10px 0 0;
  }
  .date{
    margin: 10px 0 0;
    + p{
      margin: 6px 0 0;
    }
  }

  .history_item_right{
    text-align: right;
    .used_coupon{
      margin: 6px 0 0;
      color: #555;
    }
  }

  @media screen and (min-width: 501px){
    padding: 36px 48px;
  }

  @media (max-width: 500px){
    padding: 24px;
    .history_item_right{
      max-width: 140px;
    }
  }
`